import moment from "moment";
export class DateHelper {
  static getDayAgo(date: Date, subtractDays: number) {
    return new Date(date.getTime() - subtractDays * 24 * 60 * 60 * 1000);
  }

  static addDays = function (date: Date,days) {
    days = parseInt(days, 10);
    return new Date(date.getTime()  + 1000 * 60 * 60 * 24 * days);
  }
}

export const getFormatDateByLocal = () => {
    let langCode = localStorage.getItem("lang");
    if (langCode === undefined || langCode === null) {
      langCode = "en-US";
      localStorage.setItem("lang", langCode);
    }
    let localeName = langCode.substring(0, 2) == 'nl' ? 'nl-be' : langCode.substring(0, 2);
    let localeData = moment.localeData(localeName);
    return localeData ? localeData.longDateFormat("L") : 'DD/MM/YYYY';
}